const variables = {
  logo: 'Navigation',
};

export default variables;
